import { useQuery } from '@tanstack/react-query';
import { fetchSubscriptionStartOptions } from './fetchSubscriptionStartOptions';
import { GlobalReactQueryOptions } from '../../config';

export const SUBSCRIPTION_START_OPTIONS_CACHE_KEY = 'subscriptionStartOptions';

export const useSubscriptionStartOptions = (productId: string, showPopup: boolean) => {
    return useQuery([SUBSCRIPTION_START_OPTIONS_CACHE_KEY, productId], () => fetchSubscriptionStartOptions(productId), {
        ...GlobalReactQueryOptions,
        enabled: showPopup
    });
};
